import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Layout route used to mount an entire URL subtree (e.g. /fr/*) in a fixed
// language, reusing the same page components the AR/EN toggle uses instead
// of duplicating them. i18next's language is global, so switching it here
// affects every t() call for as long as this subtree is mounted, and the
// previous language is restored on unmount so leaving /fr doesn't leave the
// rest of the site stuck in French.
function LanguageForcer({ lang }) {
  const { i18n } = useTranslation();

  useEffect(() => {
    const previousLang = i18n.language;
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    return () => {
      if (i18n.language === lang && previousLang !== lang) {
        i18n.changeLanguage(previousLang);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);

  return <Outlet />;
}

export default LanguageForcer;
